import { render, staticRenderFns } from "./RelationImport.vue?vue&type=template&id=8b6b4d7a&scoped=true"
import script from "./RelationImport.vue?vue&type=script&lang=js"
export * from "./RelationImport.vue?vue&type=script&lang=js"
import style0 from "./RelationImport.vue?vue&type=style&index=0&id=8b6b4d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b4d7a",
  null
  
)

export default component.exports